import { isObject, isObjectsSame, extractPureDataObject} from '@/utils/object'
import { isEqual, cloneDeep } from 'lodash'


/**
 * @param {{string: any}[] | string[] | number[]} originalData
 * @param {{string: any}[] | string[] | number[]} currentData
 * @returns {boolean}
 */

export const isArraysSame = async(originalData, currentData) => {

  if(originalData.length !== currentData.length) return false
  
  const cloneOriginal = await cloneDeep(originalData) 
  const cloneCurrent = await cloneDeep(currentData) 

  if(isObject(originalData[0]) && isObject(currentData[0])){
    let hasChange = false 


    for await (const item of cloneOriginal) {

      const index = cloneOriginal.indexOf(item)

      const isDiff = isEqual(extractPureDataObject(item),extractPureDataObject(cloneCurrent[index]))

      if (isDiff) {
        hasChange = true
        break;
      }
      continue;
    }

    return !hasChange
  }else{

    const original = cloneOriginal.sort()
    const current = cloneCurrent.sort()

    const isSame = original.every((value, index)=>{
      return value === current[index]
    })

    return isSame
  }


}

/**
 * compareDeepArrayByReferenceKey
 * @param {{string: any}[]} originalArray
 * @param {{string: any}[]} currentArray
 * @param {string} key
 * @returns {boolean}
 */

export const compareDeepArrayByReferenceKey = (originalArray, currentArray, key)=>{

  const mappedOriginalArray = originalArray.map((item)=>{ 
    if(!Object.hasOwn(item, key)) throw new Error(`this key : ${key} doesn't exist in original array `);
    item[key] 
  })

  const mappedCurrentArray = currentArray.map((item)=>{ 
    if(!Object.hasOwn(item, key)) throw new Error(`this key : ${key} doesn't exist in current array `);
    item[key] 
  })
  return isArraysSame(mappedOriginalArray, mappedCurrentArray)


}
/**
 * @param {Array} originalArray
 * @param {Array} currentArray
 * @returns {{[string]: any}[]}
 */
export const defineDiffDeepArray = (originalArray, currentArray) => {

  const diffObj = []
  const compareArraysWithSameLength = (oldArray, newArray)=>{
    newArray.forEach((item, index)=>{
      if(isObject(item) && !isObjectsSame(item,oldArray[index])){
        diffObj.push(item)
      }
    })
  }

  if(originalArray.length < currentArray.length ){

    const cloneCurrent = cloneDeep(currentArray)

    do {
      diffObj.push(cloneCurrent[length-1])
      cloneCurrent.pop()
    } while (originalArray.length < cloneCurrent.length);

    compareArraysWithSameLength(originalArray, cloneCurrent)

  }else{
    compareArraysWithSameLength(originalArray, currentArray)
  }
  
  return diffObj
}


export const deepCloneArray = input => {
  if (typeof input !== 'object') return input;
  const output = Array.isArray(input) ? [] : {};
  const keys = Object.keys(input);
  keys.forEach(key => {
      output[key] = deepCloneArray(input[key]);
  });
  return output;
};